import React from 'react';
import Draggable from 'react-draggable';
import './MapItems.css';
import dataTypes from '../../../../assets/json/datenTypen.json';

function calcPosition(position, size, scale) {
  return {
    x: position.x * scale - (size.width * scale) / 2,
    y: position.y * scale - (size.height * scale) / 2
  };
}

export const SingleInputItem = props => {
  const item = props.item;
  const dataKey = Object.keys(item.data)[0];

  return (
    <AbstractMapItem {...props}>
      <div style={{backgroundColor: item.ui.backgroundColor}}>
        <MapInput
          item={item}
          data={{key: dataKey, value: item.data[dataKey].value}}
          callback={props.setValueInMap}
        />
      </div>
    </AbstractMapItem>
  );
};

export const IconItem = props => {
  const item = props.item;
  const dataKey = Object.keys(item.data)[0];

  function updateIcon(index) {
    return (
      'url("' +
      item.ui.folder +
      item.ui.fileName +
      index +
      item.ui.fileExtension +
      '")'
    );
  }

  return (
    <AbstractMapItem {...props}>
      <div
        className='icon-item'
        style={{
          backgroundColor: item.ui.backgroundColor,
          backgroundImage: updateIcon(item.data.iconIndex.value)
          //
        }}>
        <MapInput
          item={item}
          data={{key: dataKey, value: item.data[dataKey].value}}
          callback={props.setValueInMap}
        />
      </div>
    </AbstractMapItem>
  );
};

export const MapInput = ({item, data: {key, value}, callback}) => {
  const [input, setInput] = React.useState(value);

  const publicChange = () => {
    callback(item, {[key]: {value: parseFloat(input)}});

    setInput(parseFloat(input).toString());
  };
  const privateChange = e =>
    setInput(e.target.value ? e.target.value.replace(',', '.') : '');

  React.useEffect(() => {
    setInput(value.toString());
  }, [value]);

  const hasUnit = typeof item.ui.unit !== 'undefined';

  return (
    <div className='map-input-wrapper'>
      <input
        className='map-input'
        style={{
          textAlign: hasUnit ? 'right' : 'center',
          width: hasUnit ? '50%' : '100%',
          color: item.ui.fontColor
        }}
        value={input}
        onChange={privateChange}
        onBlur={publicChange}
        onKeyUp={e => {
          if (e.key === 'Enter') {
            publicChange();
          }
        }}
      />

      {(() => {
        if (hasUnit) {
          return (
            <span
              className='map-input'
              style={{textAlign: 'left', color: item.ui.fontColor}}>
              {dataTypes[item.ui.unit].unit}
            </span>
          );
        }
      })()}
    </div>
  );
};
export const AbstractMapItem = props => {
  const item = props.item;
  return (
    <Draggable
      position={calcPosition(item.position, item.size, props.mapScale)}
      bounds='parent'
      disabled={true}
      // onStart={() => true
    >
      <div
        className='map-item'
        style={{
          backgroundColor: item.ui.backgroundColor,
          width: item.size.width * props.mapScale + 'px',
          height: item.size.height * props.mapScale + 'px'
        }}>
        {props.children}
      </div>
    </Draggable>
  );
};

export function StaticTextItem(props) {
  return (
    <MapItem {...props}>
      <div className='static-text-item'>{props.message}</div>
    </MapItem>
  );
}

//{`btn btn-${theme}`}
export function MapItem(props) {
  const scale = props.scale;

  function calcPosition(position, size) {
    return {
      x: position.x * scale - (size.width * scale) / 2,
      y: position.y * scale - (size.height * scale) / 2
    };
  }
  return (
    <Draggable
      position={calcPosition(props.position, props.size)}
      bounds='parent'
      onStart={() => false}>
      <div
        className='map-item'
        style={{
          backgroundColor: props.backgroundColor,
          color: props.fontColor,
          width: props.size.width * scale + 'px',
          height: props.size.height * scale + 'px'
        }}>
        {props.children}
      </div>
    </Draggable>
  );
}
